// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/carbon-monoxide-poisoning.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/carbon-monoxide-poisoning/carbon-monoxide-poisoning.js';
import g1 from '../lessons/aeronautics/carbon-monoxide-poisoning/exhaust-system-and-carbon-monoxide.js';

mount([g0, g1]);
